import $ from "jquery";
import  * as React from "react";
import { observer } from "mobx-react";
import { IFooterWithCommercialProps } from "./IFooterWithCommercialProps";


@observer
export class FooterWithCommercial extends React.Component<IFooterWithCommercialProps>{
    constructor(props: IFooterWithCommercialProps) {
        super(props, undefined);
    }

    render() {
        return <div className="footer-with-commercial hidden-print">
            {(this.props.showBottomCommercial || this.props.editModeInTps) &&
                    <div className="background-container" style={{ opacity: !this.props.showBottomCommercial ? 0.5 : 1 }} onMouseOver={() => $(".commercial-overlay-on-hover").fadeIn(500)}>
                           <div className="logo">
                               <img className="tmu-logo" src="Images/tmu-logo.png" alt="Tmu logo" />
                           </div>
                           <div className="header">
                               <p>Unleash your potential</p>
                           </div>
                           <div className="subheader">
                               <p>
                                   If you dare to learn more, this is the place to go...
                               </p>
                           </div>
                           {!this.props.isTps &&
                           <div className="commercial-button">
                               <a href="https://www.trackmanuniversity.com" target="_blank" rel="noopener noreferrer">
                                   <span>TrackMan University</span>
                               </a>
                           </div>
                           }
                           {this.props.isTps &&
                           <span className="tmu-text-tps">TrackMan University</span>
                           }
                       </div>
                    }
            {!this.props.editModeInTps &&
                <div className="commercial-replacement" style={!this.props.showBottomCommercial ? {} : { display: "none" }}>
                    <div className="logo">
                        <img className="tmu-logo" src="Images/unleash-potential-logo-new.png" alt="Tmu logo" />
                    </div>
                </div>
            }
               </div>;
    }
}
